import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './inbox.actions';
import {
  removeFavoriteSuccess,
  addToFavoriteSuccess,
} from 'app/shared/components/delivery-list/shared/favorite-btn/store/favorite-btn.actions';
import { HelperService } from 'app/core/services/helper.service';
import { InboxDelivery } from 'app/core/models/inbox-delivery.model';
import { setSearchTerm } from 'app/inbox/search/store/search.actions';

export interface InboxState {
  entities: InboxDelivery[];
  loading: boolean;
  loaded: boolean;
  unreadNumber: number;
  page?: number;
  pageType?: string;
  scrollPosition: number;
}

export const initialState: InboxState ={
  entities: [] as InboxDelivery[],
  loading: false,
  loaded: false,
  unreadNumber: 0,
  page: 0,
  pageType: '',
  scrollPosition: 0,
} as InboxState;

const createInboxReducer = createReducer(
  initialState,
  on(fromActions.showLoading, (state: InboxState) => ({
    ...state,
    loading: true,
    loaded: false,
  })),
  on(fromActions.loadDeliveries, (state: InboxState) => ({
    ...state,
    loading: true,
    loaded: false,
  })),
  on(fromActions.loadInboxSuccess, (state, action) => {
    const entities = action.payload;
    return { ...state, entities, loading: false, loaded: true };
  }),
  on(fromActions.loadMoreInboxSuccess, (state, action) => {
    const entities = [...state.entities, ...action.payload];
    return { ...state, entities, loading: false, loaded: true };
  }),
  on(setSearchTerm, (state, action) =>  ({ ...state, loading: true, loaded: false })),
  on(
    fromActions.loadInboxFail,
    fromActions.loadUnreadNumberFail,
    fromActions.searchIncomeFail,
    (state: any) => ({ ...state, loading: false, loaded: false }),
  ),
  on(fromActions.incrementPage, (state: InboxState) => {
    const page = state.page + 1;
    return { ...state, page };
  }),
  on(fromActions.setVisitedFlag, (state: any, action) => {
    const deliveryId: string = action.payload;
    const entities = state.entities.map((delivery: InboxDelivery) => {
      const deliveryInbox = { ...delivery };
      if (deliveryInbox.deliveryKeyCode === deliveryId) {
        deliveryInbox.openedDelivery = true;
      }
      return deliveryInbox;
    });
    return { ...state, entities };
  }),
  on(fromActions.loadUnreadNumberSuccess, (state: any, action) => {
    const { unreadNumber } = action;
    return { ...state, unreadNumber, loading: false };
  }),
  on(fromActions.loadUnreadNumberFail, (state: any) => {
    const unreadNumber = 0;
    return { ...state, unreadNumber, loading: false };
  }),
  on(fromActions.setPage, (state: any, action) => {
    const { page } = action;
    return { ...state, page };
  }),
  on(fromActions.resetInbox, (state: any) => {
    const initState = {
      entities: [],
      loading: false,
      loaded: false,
      unreadNumber: 0,
      page: 0,
      active: state.active,
      scrollPosition: 0,
    };
    return initState;
  }),
  on(fromActions.refresh, (state: InboxState) => (
    { ...state, page: 0, entities: [], loading: false, loaded: false }
  )),
  on(fromActions.reactivateDeliverySuccess, (state: InboxState, action) => {
    const deliveryId = action.payload;
    const entities = state.entities.map((inboxDelivery: InboxDelivery) =>
      HelperService.cloneDelivery(inboxDelivery),
    );
    const delivery = entities.find((item: any) => item.deliveryKeyCode === deliveryId);
    if (delivery) {
      delivery.resendRequested = true;
    }
    return { ...state, entities };
  }),
  on(removeFavoriteSuccess, (state: InboxState, { deliveryKeyCode }) => {
    const entities = (state.entities || []).map((delivery: InboxDelivery) => {
      const newDelivery = HelperService.cloneDelivery(delivery);
      if (newDelivery.deliveryKeyCode === deliveryKeyCode) {
        newDelivery.favourite = false;
      }
      return newDelivery;
    });
    return { ...state, entities };
  }),
  on(addToFavoriteSuccess, (state: InboxState, { delivery }) => {
    const { deliveryKeyCode } = delivery;
    const entities = (state.entities || []).map((inboxDelivery: InboxDelivery) => {
      const newDelivery = HelperService.cloneDelivery(inboxDelivery);
      if (newDelivery.deliveryKeyCode === deliveryKeyCode) {
        newDelivery.favourite = true;
      }
      return newDelivery;
    });
    return { ...state, entities };
  }),
  on(fromActions.setScrollPosition, (state: InboxState, { scrollPosition }) => (
    { ...state, scrollPosition }
  )),
);

export function inboxReducer(state: InboxState, action: Action) {
  return createInboxReducer(state, action);
}
export const inboxReducerKey = 'inboxDelivery';
